import {
  FRESHDESK_ENCRYPTED_API_KEY,
  FRESHDESK_ENCRYPTED_DOMAIN,
  FRESHDESK_TICKET_PRIORITY,
  FRESHDESK_TICKET_SOURCE,
  FRESHDESK_TICKET_STATUS,
  FRESHDESK_TICKETS_API_PATH,
} from "./config";

const decryptCredential = (encryptedText) =>
  atob(encryptedText.split("").reverse().join(""));

export const getFreshdeskDomain = () =>
  decryptCredential(FRESHDESK_ENCRYPTED_DOMAIN);

export const getFreshdeskApiKey = () =>
  decryptCredential(FRESHDESK_ENCRYPTED_API_KEY);

export const getFreshdeskTicketsApiUrl = () =>
  `https://${getFreshdeskDomain()}${FRESHDESK_TICKETS_API_PATH}`;

export const getFreshdeskAuthHeader = () =>
  `Basic ${btoa(`${getFreshdeskApiKey()}:X`)}`;

export const getTeamMemberEmails = (agentData = {}) => {
  const emails = [];

  if (agentData.teamMembers && Array.isArray(agentData.teamMembers)) {
    agentData.teamMembers.forEach((teamMember) => {
      if (teamMember.email && teamMember.email.trim()) {
        emails.push(teamMember.email.trim());
      }
    });
  }

  if (
    agentData.agentAssistantDTOs &&
    Array.isArray(agentData.agentAssistantDTOs)
  ) {
    agentData.agentAssistantDTOs.forEach((assistant) => {
      if (assistant.emailID && assistant.emailID.trim()) {
        emails.push(assistant.emailID.trim());
      }
    });
  }

  return [...new Set(emails)];
};

export const appendFreshdeskTicketDefaults = (formData) => {
  formData.append("status", FRESHDESK_TICKET_STATUS);
  formData.append("priority", FRESHDESK_TICKET_PRIORITY);
  formData.append("source", FRESHDESK_TICKET_SOURCE);
};

export const submitFreshdeskTicket = async (formData) => {
  const response = await fetch(getFreshdeskTicketsApiUrl(), {
    method: "POST",
    headers: {
      Authorization: getFreshdeskAuthHeader(),
    },
    body: formData,
  });

  if (!response.ok) {
    const error = new Error("Failed to create Freshdesk ticket.");
    error.response = response;
    throw error;
  }

  return response.json();
};

export * from "./config";
